
export function isEmailUnderToggle(email: string) {
    const emailsToggle : string[] = [
    'opote@axxess.com','axxesscareacc@gmail.com', 'skamareddi@axxess.com','tpn3k@msn.com', 'tpn3k@yahoo.com','ssobush@axxess.com',
        'oobielodan@axxess.com',"ptale@axxess.com","rreddy@axxess.com","pajayi@axxess.com","oaderibigbe@axxess.com","undukwe@axxess.com","oayeni@axxess.com","JKlein@axxess.com","securitykeymethod@yopmail.com"
    ];
    const isEmailUnderToggle = emailsToggle.includes(email) ? 'true':'false';
    window.sessionStorage.setItem('isEmailUnderToggle', isEmailUnderToggle);
}
